<template>
  <FormContainer v-if="store.estTT && store.model?.typePublic === 'Interimaire'">
    <template #title>Tuteur de l'entreprise utilisatrice</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_84"
          v-model="nomTuteurEtablissementModel"
          label="Nom"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="prenomTuteurEtablissementModel"
          label="Prénom"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_86"
          v-model="dateNaissanceTuteurEtablissementModel"
          label="Date de naissance"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_PRENOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_DATE_NAIS,
  } from '@/features/interface/demande/shared'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const nomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseUtilisatrice.nom', true)
  const prenomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseUtilisatrice.prenom', true)
  const dateNaissanceTuteurEtablissementModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseUtilisatrice.dateNaissance',
    true,
  )
</script>
